export default function (router) {
  router.onError(error => {
    const status = error.response?.status

    if (status === 401) {
      router.push({ name: 'home' })
    } else if (status === 403) {
      router.push({ name: '403' })
    } else if (status === 404) {
      router.push({ name: '404' })
    } else {
      router.push({ name: 'error' })
    }
  })
}
